// This file contains the settings which varies between the various environments (dev, prod, etc).
// Idea from: http://himanshu.gilani.info/blog/2012/09/26/bootstraping-a-node-dot-js-app-for-dev-slash-prod-environment/
module.exports =
{
    development: {
        port: 3000,
        use_webpack_dev_server: true,
        sequelize_logging: true,
        debug_show_expected_exceptions: true,
        client: {                           // <- client settings. Must contain no secret information which may not leave the server (it is sent to the clients).
            debug_logging: true
        },
        db: { // or organize this like in itktime? (http://blog.arvidandersson.se/2013/06/10/credentials-in-git-repos , https://stackoverflow.com/questions/2397822/what-is-the-best-practice-for-dealing-with-passwords-in-github)
            host: "localhost",
            port: 3306,
            database: "ddb-dk",
            username: "brevduen",
            password: "qwerty123",
            drupalHost: "localhost",
            drupalPort: 3306,
            drupalDatabase: "brevdue_drupal",
            drupalUsername: "brevduen",
            drupalPassword: "qwerty123"
        },
        drupal: {
            consumerKey: "RfC5PEK2atpL6x84ZFuYFNWtHcVnYeoj",
            consumerSecret: "A9voxBcJxhFbxBQM9jFAHkTULTx59Ldw",
            providerURL: "http://localhost/brevdue_drupal",
            resourceEndpoint: "_rest_/system/connect"
        },
        commUtility: {
            url: "brevduen://commutil",
            version: "8"
        },
        economic: {
            url: "https://restapi.e-conomic.com",
            hostname: "restapi.e-conomic.com",
            appToken: "3Q28VSRMmtWOrAp7zclPMBEK7g4aMXftnbqmvR6ceTQ1",
            grantToken: "O9BL84JRhiq7Zny3DKh2fLyCPBjrOLUs5OMaANAAsgc1",
        },
        mail: {
            defaultFrom: "Brevduen <noreply@brevduen.dk>",
            smtp: {
                host: 'email-smtp.eu-west-1.amazonaws.com',
                port: 465,
                secure: true, // use SSL
                auth: {
                    user: 'AKIAIK7OUNOX2TQT7OEQ',                           // <- ITK-time username
                    pass: 'AhCZbmaL8ekV6z9JPJe0T86GBH7l4D+YZgYtJE7htolG'
                }
            }
        },
        payment: {
            quickPay : {
                merchantId: 44335, // see Settings > Integration in the QuickPay Manager  (info about it: http://webcache.googleusercontent.com/search?q=cache:V39uFYA9x_gJ:learn.quickpay.net/helpdesk/en/articles/merchant-id-agreement-id-api-key-and-private-key-/+&cd=2&hl=en&ct=clnk&gl=dk )
                agreementId: 171333, // see Settings > Integration in the QuickPay Manager
                paymentWindowApiKey: "5777a88d9ef7ca991b588d42e70d154ce06f55e0ef27c2a9d1f14cb5b2eb1669", // see Settings > Integration in the QuickPay Manager
                merchantPrivateKey: "94f0b98218486b6ebcc3c4f679f1152aa3762f7ef5e23e379e0c20ae2df6ccf9",
                orderPrefix: "" // TODO: Make it something different from dev to dev
            },
            momsRate: 25
        },
        formats: {
            dateFormat: "DD-MM-YYYY",
            timeFormat: "HH:mm",
            dateTimeFormat: "DD-MM-YYYY HH:mm",
            timeFormatLong: "HH:mm:ss",
            dateTimeFormatLong: "DD-MM-YYYY HH:mm:ss",
        },
        files: {
            importFileLocation: "/home/jakob/test/ddb-files"
        }
    },
    test: {
        port: 3002,
        use_webpack_dev_server: false,
        sequelize_logging: true,
        debug_show_expected_exceptions: true,
        client: {                           // <- client settings. Must contain no secret information which may not leave the server (it is sent to the clients).
            debug_logging: true
        },
        db: { // or organize this like in itktime? (http://blog.arvidandersson.se/2013/06/10/credentials-in-git-repos , https://stackoverflow.com/questions/2397822/what-is-the-best-practice-for-dealing-with-passwords-in-github)
            host: "localhost",
            port: 3306,
            database: "ddb-dk",
            username: "ddb-user",
            password: "3CTFO?U+sK*O5&K!",
            drupalHost: "localhost",
            drupalPort: 3306,
            drupalDatabase: "drupal",
            drupalUsername: "ddb-user",
            drupalPassword: "3CTFO?U+sK*O5&K!"
        },
        drupal: {
            consumerKey: "gAvZrwwETsZikA4jj5JPNhnVEqc2vnh3",
            consumerSecret: "U4NF2vSAEdE6TuKGBM3MenbqUADfKc6e",
            providerURL: "https://brevduen.dk/",
            resourceEndpoint: "_rest_/system/connect"
        },
        commUtility: {
            url: "brevduen://commutil",
            version: "8"
        },
        economic: {
            url: "https://restapi.e-conomic.com",
            hostname: "restapi.e-conomic.com",
            appToken: "3Q28VSRMmtWOrAp7zclPMBEK7g4aMXftnbqmvR6ceTQ1",
            grantToken: "O9BL84JRhiq7Zny3DKh2fLyCPBjrOLUs5OMaANAAsgc1",
        },
        mail: {
            defaultFrom: "Brevduen <noreply@brevduen.dk>",
            smtp: {
                host: 'email-smtp.eu-west-1.amazonaws.com',
                port: 465,
                secure: true, // use SSL
                auth: {
                    user: 'AKIAIK7OUNOX2TQT7OEQ',                           // <- ITK-time username
                    pass: 'AhCZbmaL8ekV6z9JPJe0T86GBH7l4D+YZgYtJE7htolG'
                }
            }
        },
        payment: {
            quickPay : {
                merchantId: 44174, // see Settings > Integration in the QuickPay Manager  (info about it: http://webcache.googleusercontent.com/search?q=cache:V39uFYA9x_gJ:learn.quickpay.net/helpdesk/en/articles/merchant-id-agreement-id-api-key-and-private-key-/+&cd=2&hl=en&ct=clnk&gl=dk )
                agreementId: 170722, // see Settings > Integration in the QuickPay Manager
                paymentWindowApiKey: "c6ddc724d3833ad27fbd4aefc4afec190a3125b5886b613891df47f770c6a1f0", // see Settings > Integration in the QuickPay Manager
                merchantPrivateKey: "b27e0a94e0f3a645421b0b809f1832cb109e61abdbbb7f7c6ad3ea18ae6382e6",
                orderPrefix: "test"
            },
            momsRate: 25
        },
        formats: {
            dateFormat: "DD-MM-YYYY",
            timeFormat: "HH:mm",
            dateTimeFormat: "DD-MM-YYYY HH:mm",
            timeFormatLong: "HH:mm:ss",
            dateTimeFormatLong: "DD-MM-YYYY HH:mm:ss",
        },
        files: {
            importFileLocation: "/var/www/data/ddb-files"
        }
    },
    prod: {
        port: 3002,
        use_webpack_dev_server: false,
        sequelize_logging: false,
        debug_show_expected_exceptions: false,
        client: {                           // <- client settings. Must contain no secret information which may not leave the server (it is sent to the clients).
            debug_logging: false
        },
        db: { // or organize this like in itktime? (http://blog.arvidandersson.se/2013/06/10/credentials-in-git-repos , https://stackoverflow.com/questions/2397822/what-is-the-best-practice-for-dealing-with-passwords-in-github)
            //host: "web",
            //port: 3306,
            //database: "ddb-dk",
            //username: "dba",
            //password: "9njamaster"
            host: "localhost",
            port: 3306,
            database: "ddb-dk",
            username: "ddb-user",
            password: "3CTFO?U+sK*O5&K!",
            drupalHost: "localhost",
            drupalPort: 3306,
            drupalDatabase: "drupal",
            drupalUsername: "ddb-user",
            drupalPassword: "3CTFO?U+sK*O5&K!"
        },
        drupal: {
            consumerKey: "RfC5PEK2atpL6x84ZFuYFNWtHcVnYeoj",
            consumerSecret: "A9voxBcJxhFbxBQM9jFAHkTULTx59Ldw",
            providerURL: "https://brevduen.dk/",
            resourceEndpoint: "_rest_/system/connect"
        },
        commUtility: {
            url: "brevduen://commutil",
            version: "8"
        },
        economic: {
            url: "https://restapi.e-conomic.com",
            hostname: "restapi.e-conomic.com",
            appToken: "3Q28VSRMmtWOrAp7zclPMBEK7g4aMXftnbqmvR6ceTQ1",
            grantToken: "O9BL84JRhiq7Zny3DKh2fLyCPBjrOLUs5OMaANAAsgc1",
        },
        mail: {
            defaultFrom: "Brevduen <noreply@brevduen.dk>",
            smtp: {
                host: 'email-smtp.eu-west-1.amazonaws.com',
                port: 465,
                secure: true, // use SSL
                auth: {
                    user: 'AKIAIUD2U55CUK63YJ2A',
                    pass: 'AnwP06Y4jleDmdrjDNnWM8voYtcLk/v24Yd3quRD0niJ'
                }
            }
        },
        payment: {
            quickPay : {
                merchantId: 44174, // see Settings > Integration in the QuickPay Manager  (info about it: http://webcache.googleusercontent.com/search?q=cache:V39uFYA9x_gJ:learn.quickpay.net/helpdesk/en/articles/merchant-id-agreement-id-api-key-and-private-key-/+&cd=2&hl=en&ct=clnk&gl=dk )
                agreementId: 170722, // see Settings > Integration in the QuickPay Manager
                paymentWindowApiKey: "c6ddc724d3833ad27fbd4aefc4afec190a3125b5886b613891df47f770c6a1f0", // see Settings > Integration in the QuickPay Manager
                merchantPrivateKey: "b27e0a94e0f3a645421b0b809f1832cb109e61abdbbb7f7c6ad3ea18ae6382e6",
                orderPrefix: ""
            },
            momsRate: 25
        },
        formats: {
            dateFormat: "DD-MM-YYYY",
            timeFormat: "HH:mm",
            dateTimeFormat: "DD-MM-YYYY HH:mm",
            timeFormatLong: "HH:mm:ss",
            dateTimeFormatLong: "DD-MM-YYYY HH:mm:ss",
        },
        files: {
            importFileLocation: "/var/www/data/ddb-files"
        }
    }
};




// WEBPACK FOOTER //
// ./environment-config.js